/**
 * Converts a camelCase string to capitalized words.
 * Example: "camelCaseString" -> "Camel Case String"
 * @param str - The camelCase string to convert.
 * @returns The converted string with capitalized words.
 */
export function camelToCapitalizedWords(str: string): string {
  return str
    .replace(/([A-Z])/g, " $1")
    .replace(/^./, firstChar => firstChar.toUpperCase())
    .trim();
}
